import React, {
  useMemo,
} from 'react';
import MailIcon from '@mui/icons-material/MailOutlineRounded';
import AssignmentLateOutlinedIcon from '@mui/icons-material/AssignmentLateOutlined';
import PrinterIcon from 'core/icons/printer';
import {
  DropdownMenuItem,
} from 'core/components/DropdownMenu';
import SplitActionButton from 'core/components/SplitActionButton';

type Props = {
  disabled?: boolean;
  onPrint: () => void;
  onSend: () => void;
};

const triggerIconClass = '!w-4 !h-4 !text-inherit';

export default function FinalNoticeButton({
  disabled = false,
  onPrint,
  onSend,
}: Props) {
  const menuItems: DropdownMenuItem[] = useMemo(() => ([
    {
      id: 'print',
      label: 'Print Final Notice',
      icon: PrinterIcon,
      onSelect: onPrint,
    },
    {
      id: 'send',
      label: 'Send Final Notice',
      icon: MailIcon,
      onSelect: onSend,
    },
  ]), [onPrint, onSend]);

  return (
    <SplitActionButton
      label="Final Notice"
      onPrimaryClick={onPrint}
      items={menuItems}
      variant="outlined"
      color="inherit"
      disabled={disabled}
      startIcon={<AssignmentLateOutlinedIcon className={triggerIconClass} />}
      showArrow={false}
      paperClassName="!min-w-[10rem]"
    />
  );
}
